import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { Playbook, PlaybookStep } from "../../playbook/model/Playbook";

export const useUpdateSystemPlaybook = () => {
  const {
    data: updatedPlaybook,
    call,
    isLoading: isUpdating,
    isFailed: isUpdateFailed,
  } = useApiPrivateRequest<Playbook>((response) => new Playbook(response));

  const updatePlaybook = async (
    id: string,
    title: string,
    description?: string,
    steps?: PlaybookStep[],
    starred: boolean = false,
  ) => {
    await call(`/admin/playbooks/${id}`, "PUT", undefined, {
      title,
      description,
      steps,
      starred,
    });
  };

  return {
    updatedPlaybook,
    updatePlaybook,
    isUpdating,
    isUpdateFailed,
  };
};
